import React from 'react';
import type { PercentileLevel } from '@talentmesh/utils';
import { TypographyH4, TypographyP } from '@/Components/shadcn';
import { Aspect } from '@/Models/Aspect';
import Importance from '../../../../../../Components/Importance';
import { characteristicColClass, importanceColClass, scoreColClass } from './PersonalityCharacteristicConsts';
import PersonalityCharacteristicAspectTooltip from './PersonalityCharacteristicAspectsTooltip';

interface CharacteristicItemProps {
    characteristicName: string;
    percentileScore: number;
    percentileLevel: PercentileLevel;
    aspects: Aspect[];
    importanceRating: number;
}

function PersonalityCharacteristicItem({
    characteristicName,
    percentileScore,
    percentileLevel,
    aspects,
    importanceRating,
}: CharacteristicItemProps): React.JSX.Element {
    return (
        <>
            <div className={`${characteristicColClass} pb-4`}>
                <TypographyP className="text-foreground">{characteristicName}</TypographyP>
            </div>
            <div className={scoreColClass}>
                <div className="flex flex-row items-center justify-between gap-4">
                    <TypographyH4 className="text-muted-foreground text-base">{percentileScore}</TypographyH4>
                </div>
            </div>
            <PersonalityCharacteristicAspectTooltip
                characteristicName={characteristicName}
                percentileScore={percentileScore}
                percentileLevel={percentileLevel}
                aspects={aspects}
            />
            <div className={importanceColClass}>
                <Importance weight={importanceRating} />
            </div>
        </>
    );
}

export default PersonalityCharacteristicItem;
